/*
  Authors : initappz (Rahul Jograna)
  Website : https://initappz.com/
  App Name : Event Booking App Template
  This App Template Source code is licensed as per the
  terms found in the Website https://initappz.com/license
  Copyright and Good Faith Purchasers © 2021-present initappz.
*/
export const environment = {
  production: false,
  //APP_URL: "https://api.sanpe.hu",
  //APP_URL: "http://sg2096.ddns.net:8124",
  //APP_URL: "http://127.0.0.1:8081",
  APP_URL: "",
  TENANT_ID: "ConverzumTudomnyNyelviskolaZrt_svRo4Z"
};
